import { useState, useEffect } from "react";
import { useInbox } from "@trycourier/react-hooks";
import { getMissingNotificationTypes, getSortedNotifications, getThirtyDaysAgoFromNow } from "./utils.js";
import { useLegacyInbox } from "./useLegacyInbox.js";
function useInboxNotifications() {
  var _a;
  const courierInbox = useInbox();
  const legacyInbox = useLegacyInbox();
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterRead, setFilterRead] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const filters = {
    ...filterRead ? { read: null } : {},
    ...selectedType ? { type: selectedType } : {}
  };
  const unreadCount = ((_a = notifications.filter((n) => n.read === null)) == null ? void 0 : _a.length) || 0;
  const missingTypes = getMissingNotificationTypes(notifications);
  useEffect(() => {
    if (isLoading) {
      return;
    }
    try {
      setIsLoading(true);
      courierInbox.fetchMessages();
      legacyInbox.fetchNotifications();
    } catch (error) {
      console.error("Error fetching courier messages:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    const cutoff = getThirtyDaysAgoFromNow();
    function mergeNotificationData() {
      var _a2;
      const recentCourierMessages = ((_a2 = courierInbox.messages) == null ? void 0 : _a2.filter((m) => new Date(m.created) >= cutoff)) ?? [];
      const sortedMessages = getSortedNotifications(
        recentCourierMessages,
        legacyInbox.legacyNotifications
      );
      setNotifications(sortedMessages);
    }
    mergeNotificationData();
  }, [courierInbox.messages, legacyInbox.legacyNotifications]);
  function filteredNotifications() {
    if (Object.keys(filters).length === 0) {
      return notifications;
    }
    return notifications.filter((notification) => {
      return Object.entries(filters).every(([key, value]) => {
        const field = notification[key];
        return field === value;
      });
    });
  }
  function readNotification(notification) {
    try {
      if (notification.isLegacy) {
        legacyInbox.readNotification(notification.id);
      } else {
        courierInbox.markMessageRead(notification.id);
      }
    } catch (error) {
      console.error(error);
    }
  }
  function readAllNotification() {
    try {
      const filtered = filteredNotifications();
      const legacyNotifications = filtered.filter((n) => n.isLegacy);
      const nonLegacyNotifications = filtered.filter((n) => !n.isLegacy);
      legacyNotifications.forEach((notification) => {
        legacyInbox.readNotification(notification.id);
      });
      nonLegacyNotifications.forEach((notification) => {
        courierInbox.markMessageRead(notification.id);
      });
    } catch (error) {
      console.error(error);
    }
  }
  function deleteAllNotification() {
    try {
      const filtered = filteredNotifications();
      const legacyNotifications = filtered.filter((n) => n.isLegacy);
      const nonLegacyNotifications = filtered.filter((n) => !n.isLegacy);
      legacyNotifications.forEach((notification) => {
        legacyInbox.deleteNotification(notification.id);
      });
      nonLegacyNotifications.forEach((notification) => {
        courierInbox.markMessageArchived(notification.id);
      });
    } catch (error) {
      console.error(error);
    }
  }
  function deleteNotification(notification) {
    try {
      if (notification.isLegacy) {
        legacyInbox.deleteNotification(notification.id);
      } else {
        courierInbox.markMessageArchived(notification.id);
      }
    } catch (error) {
      console.error(error);
    }
  }
  function resetState() {
    setFilterRead(false);
    setSelectedType(null);
  }
  return {
    inboxNotifications: filteredNotifications(),
    readNotification,
    readAllNotification,
    deleteNotification,
    deleteAllNotification,
    unreadCount,
    missingTypes,
    filterRead,
    selectedType,
    setFilterRead,
    setSelectedType,
    resetState,
    isLoading: (isLoading || (courierInbox == null ? void 0 : courierInbox.isLoading)) ?? false
  };
}
export {
  useInboxNotifications as default
};
//# sourceMappingURL=useInboxNotifications.js.map
